//
// Header
//
export default class HeaderMenu {
  constructor($ele) {
    this.$body = document.body;
    this.$pageHeader = $ele;
    this.$menuBar = $ele.querySelector('#menuTrigger');
    this.$mainMenu = $ele.querySelector('navigation');
    this.$nav_list = $ele.querySelectorAll('.nav-items');
    this.$nav_items = $ele.querySelectorAll('.nav-items li');
    this.$navArrow = $ele.querySelectorAll('.navigation .has-sub .nav-arrow');
    this.$navHasMenuLink = $ele.querySelectorAll(
      '.navigation .has-sub .has-menu-link, .navigation .has-sub .has-second-menu-link'
    );
    this.$langTrighger = $ele.querySelectorAll('.page-header__lang-trigger');

    this.menuTrigger();
    this.menuOpen();
    this.onResize();
    this.languageDropdown();
    this.firstMenuOpen();
    this.navHasMenuLinks();
  }

  firstMenuOpen() {
    // First SubMenu Open
    let hasActiveSubPage = false;
    
    // Check if any submenu item has active class
    this.$navArrow.forEach(($e) => {
      const menuItem = $e.parentNode;
      const subMenu = menuItem.querySelector('.sub-menu--second');
      if (subMenu) {
        const activeSubItems = subMenu.querySelectorAll('.nav-item-second.active, .nav-item-second .active, .nav-item-second a.active');
        if (activeSubItems.length > 0) {
          hasActiveSubPage = true;
        }
      }
    });
    
    // Handle first menu item active-page class and close/open state
    if (this.$navArrow.length > 0) {
      const firstMenuItem = this.$navArrow[0].parentNode;
      const firstSubMenu = firstMenuItem.querySelector('.sub-menu--second');
      
      if (firstMenuItem.classList.contains('has-sub')) {
        if (hasActiveSubPage) {
          // If submenu item is active, remove active-page and close first menu
          firstMenuItem.classList.remove('active-page');
          firstMenuItem.classList.remove('has-sub--open');
          if (firstSubMenu) {
            firstSubMenu.style.maxHeight = '0px';
          }
        } else {
          // If no submenu item is active, add active-page to first menu item
          firstMenuItem.classList.add('active-page');
        }
      }
    }
    
    // Handle menu open/close logic
    this.$navArrow.forEach(($e) => {
      const menuItem = $e.parentNode;
      const subMenu = menuItem.querySelector('.sub-menu--second');
      
      if (subMenu) {
        // Check if this menu has active sub-items
        const activeSubItems = subMenu.querySelectorAll('.nav-item-second.active, .nav-item-second .active, .nav-item-second a.active');
        const hasActiveSubItems = activeSubItems.length > 0;
        
        // Check if this is the first menu item
        const isFirstMenuItem = this.$navArrow[0] && $e === this.$navArrow[0];
        
        if (hasActiveSubItems) {
          // If this menu has active sub-items, open it
          let subHeight = 0;
          subMenu.querySelectorAll('.sub-menu li').forEach((subEl) => {
            subHeight += subEl.getBoundingClientRect().height;
          });
          menuItem.classList.add('has-sub--open');
          subMenu.style.maxHeight = subHeight + 'px';
        } else if (isFirstMenuItem && !hasActiveSubPage && menuItem.classList.contains('active-page')) {
          // Only open first menu if no submenu items are active anywhere and it has active-page
          let subHeight = 0;
          subMenu.querySelectorAll('.sub-menu li').forEach((subEl) => {
            subHeight += subEl.getBoundingClientRect().height;
          });
          menuItem.classList.add('has-sub--open');
          subMenu.style.maxHeight = subHeight + 'px';
        } else {
          // Close menu if it doesn't meet the conditions above
          menuItem.classList.remove('has-sub--open');
          subMenu.style.maxHeight = '0px';
        }
      }
    });
  }

  onResize() {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 992) {
        if (this.$body.classList.contains('menu--open')) {
          this.$body.classList.remove('menu--open');
        }
      }
    });
  }

  // Language Dropdown
  languageDropdown() {
    this.$langTrighger.forEach(($lang) => {
      $lang.addEventListener('click', () => {
        const langDropdown = $lang.parentNode.querySelector('.page-header__language-ddr');
        if (langDropdown) {
          langDropdown.classList.toggle('page-header__language-ddr--open');
        }

        if (langDropdown.classList.contains('page-header__language-ddr--open')) {
          langDropdown.style.display = 'block';
        } else {
          langDropdown.style.display = 'none';
        }
      });
    });
  }

  // Menu Trigger
  menuTrigger() {
    this.$menuBar.addEventListener('click', () => {
      this.$body.classList.toggle('menu--open');
    });
  }

  getSubMenuForItem(menuItem) {
    return (
      menuItem.querySelector(':scope > .sub-menu--second') ||
      menuItem.querySelector(':scope > .sub-menu--third')
    );
  }

  toggleSubMenu(menuItem) {
    const subMenu = this.getSubMenuForItem(menuItem);
    if (!subMenu) {
      return;
    }

    this.removeChildFromSiblings(menuItem);

    let subHeight = 0;
    subMenu.querySelectorAll('li').forEach((subEl) => {
      subHeight += subEl.getBoundingClientRect().height;
    });

    menuItem.classList.toggle('has-sub--open');

    if (menuItem.classList.contains('has-sub--open')) {
      subMenu.style.maxHeight = `${subHeight}px`;
    } else {
      subMenu.style.maxHeight = '0px';
    }
  }

  // menu Open Mobile devices
  menuOpen() {
    this.$navArrow.forEach(($e) => {
      $e.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.toggleSubMenu($e.parentNode);
      });
    });
  }

  // Nav Has Menu Links
  navHasMenuLinks() {
    this.$navHasMenuLink.forEach(($ele) => {
      $ele.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleSubMenu($ele.parentNode);
      });
    });
  }

  removeChildFromSiblings(elem) {
    const siblings = [];

    if (!elem.parentNode) {
      return siblings;
    }

    let sibling = elem.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        sibling.classList.remove('active');
        if (sibling.querySelector('.sub-menu--second')) {
          sibling.querySelector('.sub-menu--second').style.maxHeight = 0 + 'px';
        }
        sibling.classList.remove('has-sub--open');
      }
      sibling = sibling.nextElementSibling;
    }
    return siblings;
  }
}

let headerStickyAbort = null;

const DESKTOP_NAV_MIN_WIDTH = 992;

/** Active Barba view — header lives inside the swapped container. */
const getBarbaContainer = () =>
  document.querySelector('[data-barba="container"]');

export const getPageHeader = () => {
  const container = getBarbaContainer();
  return (
    container?.querySelector('.page-header') ??
    document.querySelector('.page-header')
  );
};

export const initHeaderSticky = () => {
  if (headerStickyAbort) {
    headerStickyAbort.abort();
  }

  headerStickyAbort = new AbortController();
  const { signal } = headerStickyAbort;

  const header = getPageHeader();
  if (!header) {
    return;
  }

  let lastScrollTop = 0;

  const onScroll = () => {
    const activeHeader = getPageHeader();
    if (!activeHeader) {
      return;
    }

    const glossaryScrolling = document.documentElement.classList.contains('glossary-scrolling');
    const isDesktopNav = window.innerWidth >= DESKTOP_NAV_MIN_WIDTH;

    if (isDesktopNav && !glossaryScrolling) {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop) {
        activeHeader.classList.remove('header--pinned');
        activeHeader.classList.add('header--unpinned');
      } else {
        activeHeader.classList.remove('header--unpinned');
        activeHeader.classList.add('header--pinned');
      }
      lastScrollTop = st <= 0 ? 0 : st;
    } else {
      activeHeader.classList.remove('header--unpinned');
      activeHeader.classList.add('header--pinned');
      lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    activeHeader.classList.toggle('header-sticky', window.scrollY > 40);
  };

  header.classList.remove('header--unpinned', 'header-sticky');
  header.classList.add('header--pinned');

  window.addEventListener('scroll', onScroll, { signal, passive: true });
  window.addEventListener('resize', onScroll, { signal, passive: true });
  document.documentElement.addEventListener('glossary-scroll-end', onScroll, { signal });
  onScroll();
};

const isSubmenuParentLink = (link) => {
  const parentLi = link?.closest('li.has-sub, li.nav-item-second.has-sub');
  if (!parentLi) {
    return false;
  }

  const directLink = parentLi.querySelector(':scope > a[href]');
  if (directLink !== link) {
    return false;
  }

  return Boolean(
    parentLi.querySelector(':scope > .sub-menu--second') ||
      parentLi.querySelector(':scope > .sub-menu--third')
  );
};

const isNavMenuToggleLink = (link) => {
  if (!link) {
    return false;
  }

  if (link.id === 'menuTrigger') {
    return true;
  }

  const className = typeof link.className === 'string' ? link.className : '';

  if (
    className.includes('has-menu-link') ||
    className.includes('has-second-menu-link')
  ) {
    return true;
  }

  return isSubmenuParentLink(link);
};

const isExcludedNavLink = (link) => {
  const href = link.getAttribute('href') || '';

  if (!href || href === '#' || href.startsWith('#')) {
    return true;
  }

  if (/^(javascript:|tel:|mailto:)/i.test(href)) {
    return true;
  }

  if (link.hasAttribute('target') && link.getAttribute('target') !== '_self') {
    return true;
  }

  if (
    link.hasAttribute('data-fancybox') ||
    link.hasAttribute('data-bs-toggle') ||
    link.hasAttribute('data-glightbox') ||
    link.hasAttribute('data-darkbox') ||
    link.hasAttribute('data-barba-prevent')
  ) {
    return true;
  }

  const className = typeof link.className === 'string' ? link.className : '';

  return (
    className.includes('filterBlogs') ||
    className.includes('blogpagination__link') ||
    className.includes('lightbox')
  );
};

export const closeHeaderMenu = () => {
  document.body.classList.remove('menu--open');

  const header = getPageHeader();

  (header ?? document).querySelectorAll('.has-sub--open').forEach((item) => {
    item.classList.remove('has-sub--open');
    const subMenu = item.querySelector('.sub-menu--second');
    if (subMenu) {
      subMenu.style.maxHeight = '0px';
    }
  });
};

let headerNavCloseRegistered = false;

const registerHeaderNavCloseOnClick = () => {
  if (headerNavCloseRegistered) {
    return;
  }
  headerNavCloseRegistered = true;

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link?.closest('.page-header .navigation')) {
      return;
    }

    if (isNavMenuToggleLink(link) || isExcludedNavLink(link)) {
      return;
    }

    closeHeaderMenu();
  });
};

export const initHeader = () => {
  const container = getBarbaContainer();
  const headers = container
    ? container.querySelectorAll('.page-header')
    : document.querySelectorAll('.page-header');

  headers.forEach(($el) => {
    if ($el.dataset.headerInitialized === '1') {
      return;
    }

    new HeaderMenu($el);
    $el.dataset.headerInitialized = '1';
  });

  initHeaderSticky();
  registerHeaderNavCloseOnClick();
};

const bootHeader = () => {
  initHeader();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootHeader, { once: true });
} else {
  bootHeader();
}

// Re-bind sticky header after Barba swaps the container (new .page-header node).
document.addEventListener('barba:after-enter', () => {
  requestAnimationFrame(() => {
    initHeaderSticky();
  });
});

document.addEventListener('click', (event) => {
  //  if (event.target.href && !event.target.href.includes('tel:') && !event.target.href.includes('javascript:;') && !event.target.href.includes('mailto:') && event.target.tagName === 'A' && !event.target.hasAttribute('target') && !event.target.hasAttribute('data-fancybox') && !event.target.hasAttribute('data-bs-toggle', 'modal') && !event.target.hasAttribute('data-glightbox') && !event.target.hasAttribute('data-darkbox') && !event.target.className.includes('cboxElement') && !event.target.className.includes('has-menu-link') && !event.target.className.includes('has-second-menu-link')) {    // Let's check for exclude links
  //   const url = event.target.href;
  //   const parser = document.createElement('a');
  //   parser.href = url;
  //   setTimeout(() => {
  //     if (document.querySelector('body').classList.contains('cursor-drag')) {
  //       document.querySelector('body').classList.remove('cursor-drag');
  //     }
  //     if (document.querySelector('body').classList.contains('cursor-circle')) {
  //       document.querySelector('body').classList.remove('cursor-circle');
  //     }
  //   }, 300);


  //     fetch(url, {cache: "force-cache"}).then((response) => response.text()).then((html) => {
  //       const parser = new DOMParser();
  //       const doc = parser.parseFromString(html, 'text/html');
  //       const mainBody = doc.querySelector('body').getAttribute('class');
  //       setTimeout(() => {
  //         if (mainBody) {
  //           document.querySelector('body').className = mainBody;
  //         }
  //       }, 300);
  //     }).catch((err) => {
  //         console.warn(this.options.errorMsg, err);
  //     });
  //   }
});
